import * as types from 'action/actionTypes';
import * as url from 'api/url';
import APIutil from 'api/APIutils';
import { global_error_handling } from 'action/GlobalErrorMgmtAction';

/* Action to Store method returns the action type with the API response. The response object{type,response}
 will be returned to the Reducer checking its type and updates the state. */
 export function actionToStoreSuccess(response, actionType) {
    return {
        type: actionType,
        getResponse: response,
    }
}



// Fetching Reports Recurrrence List 
export function getSchedulesRecurrenceList(reportId) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Schedules_Recurrence_List + reportId + "/scheduleDetails").then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(getSchedulesReportList(reportId,response));
        }).catch(error => {
            throw error;
        })
    }
}

// Fetching Single date Reports Recurrrence List 
export function getSchedulesReportList(reportId,recurenceresponse) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Schedules_Recurrence_List + reportId + "/scheduleCalendar").then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(setRecurrenceDetails(recurenceresponse,response))
        }).catch(error => {
            throw error;
        })
    }
}

// Fetching  Reports  Mail List 
export function getSchedulesMailist(reportId) {     
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Schedules_Recurrence_List + reportId + "/emailDetails").then(response => {
            dispatch(global_error_handling(response));
            if (response !== null && response !== undefined)
                dispatch(actionToStoreSuccess(response, types.GET_SCHEDULES_MAIL_LIST));
        }).catch(error => {
            throw error;
        })
    }
}

// SaveEdit Report Schedules
export function saveReportSchedule(data){
    return function (dispatch) {
        return APIutil.editDataAPI(url.put_Schedules_Recurrence_List,data).then(response =>{
            dispatch(global_error_handling(response));
        }).catch(error => { throw error; })
    }
}


// Dispatch Report ID to be used in Export Recurrence Page
export function setSelectedReportID(reportId) {  
    return {
        type: types.SELECTED_REPORT_ID,
        reportId: reportId,
    }                                                                        
}

// Dispatch recuurence details Export Recurrence Page
export function setRecurrenceDetails(recurrenceResponse,reportResponse) {  
    return {
        type: types.GET_SCHEDULES_RECURRENCE_LIST,
        payload: {recurrenceDetails:recurrenceResponse, reportDetails:reportResponse},
    }                                                                        
}
